
export function _url(add) {
	return '/' + global.lang  + (add ? add : '')
}

export function _baseUrl(add) {
	return process.env.BASE_URL + (add ? add : '');
}